<template>
  <div class="flex flex-col overflow-x-hidden min-h-[calc(100dvh-66px-1px)]">
    <div v-if="props.header">
      <Header></Header>
    </div>
    <div class="flex-1">
      <Breadcrumbs  :self-breadcrumb="getBreadcrumb"/>
      <slot></slot>
    </div>
    <div v-if="props.footer">
      <Footer></Footer>
    </div>
  </div>
</template>
<script setup>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import {provide, inject, reactive, computed} from "vue";
import Breadcrumbs from "~/components/Breadcrumbs.vue";
import {useBasicLayoutStore} from "~/stores/basicLayout";
/*const props = defineProps({
  header: {
    type: Boolean,
    default: true
  },
  footer: {
    type: Boolean,
    default: true
  }
})*/
const basicLayoutStore = useBasicLayoutStore();

const getBreadcrumb = computed(() => basicLayoutStore.getBreadcrumb);


const defaultProps = {
  header: true,
  footer: true,
  selfCrumb: '空間便利店'
};



const providedProps = inject('searchBasicLayoutProps', defaultProps);
const props = reactive({ ...defaultProps, ...providedProps });

/*function updateHeader(value) {
  defaultProps.header = value
}
function updateFooter(value) {
  defaultProps.footer = value
}

provide('searchBasicLayoutSetting', {
  updateHeader,
  updateFooter
})*/

</script>
<style scoped
       lang="scss">

</style>
